import { ContinueResponse, Endpoint, SignCancelRequest } from '../class/class';
import { handleErrorResponse, httpRequest, logd } from '../utils/utils';

export class SignCancel extends Endpoint {
  static endpoint = 'qsl_sign_cancel';

  constructor() {
    super();
  }

  async doSignCancel(isAltFlowUsed = false): Promise<ContinueResponse> {
    const req = new SignCancelRequest(isAltFlowUsed);
    logd(() =>
      console.log('%c doSignCancel -> %c', 'color:#F60', 'color:#000', req),
    );
    try {
      const resp = await httpRequest<ContinueResponse>(
        `${this.baseUrl}${SignCancel.endpoint}`,
        req,
      );
      return new ContinueResponse(resp.json);
    } catch (error) {
      handleErrorResponse(error as AppModel.HttpResponseErrorJson);
    }
  }
}
